import 'isotope-fit-columns/fit-columns';

export function initReferenceList(){
    var Isotope = require('isotope-layout');
    if ($('.m-reflist').length) {
        var iso = new Isotope( '.m-reflist', {
            itemSelector: '.a-refentry',
            percentPosition: true,
            
            masonry: {
                columnWidth: '.a-refentry',
                gutter: 16
            }
        });

        const filters = [   'regional',
                            'wohnen',
                            'öffentlich',
                            'diakonie',
                            'energie',
                            'namedropping',
                            'beratung',
                            'stadt',
                            'mobility',
                            'medical',
                            'alle'];

        function registerFilter(target, filter){
            $(target).on('click', (e)=>{
                e.preventDefault();
                $('.a-refcatlink').removeClass('active');
                $(e.target).addClass('active');
                if(filter==='.alle'){
                    iso.arrange({ filter: '.a-refentry'});
                } else{
                    iso.arrange({ filter: filter});
                }   
                var $this = $(this),
                    $list = $('.m-reflist');
                $('html,body').delay(500).animate({scrollTop: $list.offset().top-70}, 400);
                
            });
        }
                            
        filters.map((f)=>{
            const   target = '#'+f,
                    filter = '.'+f;
            registerFilter(target,filter);
        })

        
        
    }
    
    window.onload = function () {
        if (iso) iso.layout();
    };

}